export const PRIVACY_TERMS_SITES = [
  {
    name: 'Drive',
    displayUrl: 'https://drive.co.uk',
    url: 'https://drive.co.uk',
  },
  {
    name: 'BuyaCar',
    url: 'https://www.buyacar.co.uk',
  },
  {
    name: 'PriceAnyCar',
    url: 'https://priceanycar.com',
  },
  {
    name: 'PriceAnyVan',
    url: 'https://priceanyvan.com',
  },
  {
    name: 'RAC Cars',
    url: 'https://cars.rac.co.uk',
  },
];
